

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface BillParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
}

export class Insurance {
  insName: any;
  payerType: any;
  insPolicyFor: any;
  insCardNumber: any;
  insPolicyName: any;
  insPolicyNumber: any;
  insValidUpto: any;
  insPolicyHolderName: any;
}

export interface Bill {
  totalAmount: any;
  taxAmount: any;
  taxPercentage: any;
  netAmount: any;
  discountType?: any;
  physicianId: any;
  tenantId: any;
  branchId: any;
  discountValue?: any;
  discountAmount?: any;
  billDate: Date;
  parameters?: BillParameter[];
  BillDetailList: Array<BillDetail>;
  BillPaymentList: Array<BillPayment>;
  

}


export interface BillDetail {
  charges: any;
  serviceId: any;
  qty: any;
  rate: any;
  billId: number;
  tenantId: any;
  branchId: any;
  refMode:  any;
  refEmpId:  any;
   refClinicId:  any;
    refDocId:  any;
    othersName:  any;
  othersPhone:  any;
 othersAddress:  any;
 serviceDiscountType:any;
 serviceDiscountAmount:any;
 serviceDiscountPercentage:any;
 serviceNetAmount:any;
 serviceCategoryName:any;
}

export class BillPayment {

  paymentType: any;
  payer: any;
  cash: any;
  creditCard: any;
  online: any;
  cheque: any;
  dd: any;
  cardNo: any;
  chequeNo: any;
  ddNo: any;
  billId: number;
  tenantId: any;
  branchId: any;

}

export class CommonPayment {

  id?: any;
  paymentDoneFrom: any;
  tenantId: any;
  branchId: any;
  payerId: any;
  payerReference: any;
  uPIPaymentID: any;
  uPIReferenceNo: any;
  ddBank: any;
  ddBranch: any;
  ddDate: any;
  ddNo: any;
  chequeBranch: any;
  chequeBank: any;
  chequeDate: any;
  chequeNo: any;
  transactionNo: any;
  cardType: any;
  cardNo: any;
  dd: any;
  cheque: any;
  uPIPayment: any;
  debitCard: any;
  creditCard: any;
  cash: any;
  billId: any;
  paymentReferenceId: any;
  paymentType: any;
  regId: any;
}
export interface BillMaster {

  netAmount: any;
  holdBillId?:any;
  notes?:string;
  discountType?: any;
  discountAmount?: any;
  taxPercentage: any;
  discountValue?: any;
  taxAmount: any;
  tenantId: any;
  branchId: any;
  billDate: any;
  regId: any;
  status: any;
  totalAmount:any;
  links?: any;
  physicianId: any;
  paidAmount: any;
  balanceAmount: any;
  billNumber:any;
  paidTemplateId?:any;
  holdTemplateId?:any;
  patientFirstName?:any;
  patientMobileNumber?:any;
  billDetail?:BillDetail[];
  commonPayment?:CommonPayment[];
  woid?:any;
  emergencyFlag?:any;

  //Log
    createdDate?:Date;
    updatedDate?:Date;
    createdBy?:number;
    updatedBy?:number;
    createdIP?:string;
    updatedIP?:string;
}



export interface BillReceipt {

  id?: any;
  receiptDate: any;
  receiptAmount: any;
  billId: any;
  tenantId: any;
  branchId: any;
  regId: any;
  admissionId: any;
  payerId: any;
  ipBillId: any;
  doneFrom:any;
  opBillNumber:any;
  ipBillNumber:any;
  receiptNumber:any;
   links?: any;

}

export abstract class BillData {
  abstract get(url: string): Observable<any[]>;
  abstract list(url: string): Observable<BillMaster[]>;
  abstract listByParams(url:string, regId:string, woFrom:string, refId:string, dpRegId:string):Observable<BillMaster[]>;
  abstract getbyid(url: string): Observable<any[]>;
  abstract create(url: string, data: any[]): Observable<any>;
  abstract createBillMaster(url: string, data: BillMaster): Observable<any>;
  abstract createBillPayment(url: string, data: BillPayment): Observable<any>;
  abstract update(url: string, data: any): Observable<any>;
  abstract delete(url: string): Observable<any>;
  abstract deletehold(url: string, data: any): Observable<any>;
  abstract billDtllist(url: string): Observable<BillDetail[]>;
  abstract updateBillMaster(url: string, data: BillMaster): Observable<any>;
  abstract updateBillPayment(url: string, data: BillPayment): Observable<any>;
  abstract deleteBillDtlTable(url: string): Observable<any>;
  abstract billPaymentlist(url: string): Observable<BillPayment[]>;
  abstract BillServiceRevenuelist(url: string): Observable<any[]>;
  abstract GetdiagnosisCount(url: string): Observable<any[]>;
  abstract TenantBranch(url: string): Observable<any[]>;
  abstract cancelBill(url: string, data): Observable<any>;

//**

  abstract billTodaylist(url: string): Observable<any[]>
  abstract billYesterdaylist(url: string): Observable<any[]>
  abstract billWeeklylist(url: string): Observable<any[]>
  abstract billMonthlylist(url: string): Observable<any[]>
  abstract billYearlylist(url: string): Observable<any[]>
  
  abstract billDailylist(url: string): Observable<any[]>
  abstract serviceWiseList(url: string): Observable<any[]>

  abstract serviceTodaylist(url: string): Observable<any[]>
  abstract serviceYesterdaylist(url: string): Observable<any[]>
  abstract serviceWeeklylist(url: string): Observable<any[]>
  abstract serviceMonthlylist(url: string): Observable<any[]>
  abstract serviceYearlylist(url: string): Observable<any[]>


  //Common Payment
  abstract createCommonPayment(url: string, data: any[]): Observable<any>;
  abstract commonPaymentList(url: string): Observable<any[]>;
  abstract deleteBillCommonPayment(url: string): Observable<any>;

  //Patient Payment Servicea
  abstract patientPaymentServices(url: string): Observable<any[]>;


  //Bill Receipt
  abstract createBillReceipt(url: string, data: any): Observable<any>;
  abstract billReceiptList(url: string): Observable<any[]>;
  abstract updateBillReceipt(url: string, data: BillReceipt): Observable<any>;

  //Advance
  abstract advancelist(url: string): Observable<any>;
  abstract advancecreate(url: string, data: any): Observable<any>;
  abstract advanceupdate(url: string, data: any): Observable<any>;
  abstract advancedelete(url: string): Observable<any>;
  abstract advancesearchList(url: string,data:any): Observable<any>;

  // credit-bill-insurance
  abstract creditbilllist(url: string): Observable<any>;
  abstract creditbillsearchList(url: string,data:any): Observable<any>;

  abstract createbillOPDSlip(url: string,data:any): Observable<any>;
}
